import Hashids from 'hashids'

export function getHash () {
  const outputHashids = new Hashids('X5lM3VPyBvm', 32, '0123456789abcdef')
  return outputHashids.encode([5566001, Date.now()])
}
